/**
 * Client-side CSV export. Pure `toCsv` + a tiny browser download helper.
 * RFC 4180 quoting; cells that start with = + - @ are prefixed with ' so a
 * spreadsheet never evaluates them as formulas (CSV injection).
 */

const FORMULA = /^[=+\-@\t\r]/;

export function csvCell(value) {
  if (value == null) return '';
  let s = String(value);
  if (FORMULA.test(s) && !/^-?\d+(\.\d+)?$/.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** columns: [{ key, label, value?: (row) => any }] */
export function toCsv(rows, columns) {
  const head = columns.map((c) => csvCell(c.label)).join(',');
  const body = (rows || []).map((r) => columns.map((c) => csvCell(c.value ? c.value(r) : r[c.key])).join(','));
  return [head, ...body].join('\r\n');
}

/** Paise → '1234.50' (no currency symbol, for spreadsheets). */
export const paiseToRupees = (p) => (p == null ? '' : (Number(p) / 100).toFixed(2));

/** Trigger a download of `text` as `filename` (browser only). */
export function downloadText(filename, text, type = 'text/csv;charset=utf-8') {
  const blob = new Blob([text], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
